import _ from 'lodash';
export const FILE_IMAGE = 'FILE_IMAGE';
export const FILE_PDF = 'FILE_PDF';
export const FILE_WORD = 'FILE_WORD';
export const FILE_EXCEL = 'FILE_EXCEL';
export const FILE_UNKNOWN = 'FILE_UNKNOWN';
export const getBase64 = (file, cb) => {
  let reader = new FileReader();
  reader.readAsDataURL(file);

  reader.onload = function () {
    cb(reader.result);
  };

  reader.onerror = function (error) {
    console.log('Error: ', error);
  };
};
export const retrieveImageFromClipboardAsBlob = (pasteEvent, callback) => {
  if (!pasteEvent.clipboardData) {
    if (typeof callback == "function") {
      callback(undefined);
    }
  }

  let items = pasteEvent.clipboardData.items;

  if (items === undefined) {
    if (typeof callback == "function") {
      callback(undefined);
    }
  } // only check for the latest item from clipboard


  if (items[0].type.indexOf("image") >= 0) {
    let blob = items[0].getAsFile();

    if (typeof callback === "function") {
      callback(blob);
    }
  }
};
export const getFileType = file => {
  const {
    extension,
    contentType
  } = file;

  const lowerExtension = _.toLower(extension);

  const lowerContentType = _.toLower(contentType);

  if (lowerContentType.indexOf('image') >= 0) {
    return FILE_IMAGE;
  }

  if (lowerExtension.indexOf('pdf') >= 0) {
    return FILE_PDF;
  }

  if (lowerExtension.indexOf('doc') >= 0) {
    return FILE_WORD;
  }

  if (lowerExtension.indexOf('xls') >= 0) {
    return FILE_EXCEL;
  }

  return FILE_UNKNOWN;
};
export const extractFileName = fullName => {
  return fullName.match(/([^\/]+)(?=\.\w+$)/)[0];
};
export const extractFileExtension = fullName => {
  return fullName.match(/\.[0-9a-z]+$/i)[0].replace('.', '');
};